import { Controller } from "stimulus";

// The repo's TypeScript lib typings predate HTMLDialogElement.showModal/close.
type ModalDialog = HTMLElement & { showModal(): void; close(): void };

export default class extends Controller {
  static targets = ["dialog"];
  static values = { draftCount: Number };

  declare dialogTarget: ModalDialog;
  declare hasDialogTarget: boolean;
  declare draftCountValue: number;

  intercept(event: Event): void {
    if (this.draftCountValue <= 0 || !this.hasDialogTarget) return;

    event.preventDefault();
    this.dialogTarget.showModal();
  }

  stay(): void {
    this.dialogTarget.close();
  }
}
